module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header blueHeader",
    style: (_vm.cardHeaderBackgroundColor),
    on: {
      "click": function($event) {
        return _vm.hideBlock($event)
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$t(_vm.label)) + "\n  "), _c('i', {
    staticClass: "f7-icons headerChevron"
  }, [_vm._v("chevron_right")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-637e1d3a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-637e1d3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/cardHeader.vue
// module id = 2437
// module chunks = 2